// extracted by mini-css-extract-plugin
module.exports = {"warning":"generateVgVideoCeremonyForm_warning__2uPEz","error":"generateVgVideoCeremonyForm_error__1jKZK"};